<template>
    <div class="m-activities">
        <div v-if="!showZuopinList">
            <div class="title_wrap">
                <p class="page_title">{{ $t('my.activity') }}</p>
            </div>
            <div class="filter_wrap">
                <primarySelect
                    v-model="listQuery.status "
                    :data="statusOptions"
                    :placeholder="$t('my.statusPlhder')"
                    clearable
                />
                <el-input
                    v-model="listQuery.title"
                    clearable
                    style="width: 250px;"
                    class="filter_item mr_10 ml_10"
                    :placeholder="$t('my.keyPlhder')"
                    @keyup.enter.native="handleFilter"
                />
                <el-button
                    v-waves
                    class="filter_btn"
                    type="primary"
                    @click="handleFilter"
                >{{ $t('my.filter') }}</el-button>
            </div>
            <div
                v-loading="listLoading"
                class="list"
            >
                <div class="theader">
                    <p class="lis flex_1">{{ $t('my.num') }}</p>
                    <p class="lis flex_2">{{ $t('my.activityName') }}</p>
                    <p class="lis flex_1 lis_wrap">{{ $t('my.desc') }}</p>
                    <p class="lis flex_2">{{ $t('my.createTime') }}</p>
                    <p class="lis flex_1">{{ $t('my.status') }}</p>
                    <p class="lis flex_2 opera">{{ $t('my.operate') }}</p>
                </div>
                <div
                    v-for="(item,index) in list"
                    :key="index"
                    class="theader tbody"
                >
                    <p class="lis flex_1">{{ index+1 }}</p>
                    <p class="lis flex_2">{{ item.title }}</p>
                    <p class="lis flex_1 lis_wrap">{{ item.note }}</p>
                    <p class="lis flex_2">{{ item.created_at }}</p>
                    <p class="lis flex_1">{{ item.status ==10 ? $t('my.enable'): $t('my.disabled') }}</p>
                    <div class="lis flex_2 opera">
                        <el-button
                            type="primary"
                            size="default"
                            class="opera_tn"
                            @click="toZuopinList(item)"
                        >{{ $t('my.view') }}</el-button>
                        <el-button
                            type="primary"
                            size="default"
                            :loading="currentIndex===index && goLoading"
                            class="opera_tn"
                            @click="toPage('/home',item.id,index)"
                        >{{ $t('my.apply') }}</el-button>
                    </div>
                </div>
            </div>
            <pagination
                v-show="total>0"
                :total="total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                @pagination="getList"
            />
        </div>
        <div v-else>
            <ZuopinList
                :tid="Number(tid)"
                :title="zuopintitle"
                @close="showZuopinList=false"
            />
        </div>
    </div>
</template>

<script>
import waves from '@/directive/waves'
import Pagination from '@/components/Pagination'
import primarySelect from '@/components/primarySelect'
import ZuopinList from './zuopinList'
import { getTid, setTid } from '@/utils/cookies'
import { touGaoList } from '@/api/Tougaos'

export default {
    name: 'Activities',
    directives: { waves },
    components: { primarySelect, Pagination, ZuopinList },
    data() {
        return {
            goLoading: false,
            currentUrl: this.$route.path,
            statusOptions: [
                { key: 10, value: this.$t('my.enable') },
                { key: 20, value: this.$t('my.disabled') }
            ],
            currentIndex: -1,
            showZuopinList: this.$route.query.isShow ? Boolean(this.$route.query.isShow) : false,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zuopintitle: '',
            listQuery: {
                title: '',
                status: '',
                page: 1,
                limit: 15
            },
            listLoading: true,
            total: 0,
            list: []
        }
    },
    created() {
        this.getList()
        this.tid ? setTid(this.tid) : ''
    },
    methods: {
        handleFilter() {
            this.list = []
            this.listQuery.page = 1
            this.getList()
        },
        getList() {
            this.listLoading = true
            touGaoList(this.listQuery).then(res => {
                if (res.code === 200) {
                    this.list = res.data.list
                    this.total = res.data.total

                    setTimeout(() => {
                        this.listLoading = false
                    }, 0.5 * 1000)
                }
            })
        },
        async toPage(url, id, index) {
            setTid(id)
            this.currentIndex = index
            this.goLoading = true
            await this.$store.dispatch('tougao/getTouGaoInfo', { id: id })
            await this.$store.dispatch('tougao/getTouGaoSetting', { tid: id })
            await this.$store.dispatch('tougao/getBanner', { tid: id, type: 10 })
            await this.$store.dispatch('tougao/getCategoryList', { tid: id })
            this.goLoading = false
            this.$route.path !== url ? this.$router.push({ path: url, query: { tid: id } }) : ''
        },
        async toZuopinList(item) {
            console.log('getTid()', typeof (getTid()), typeof (item.id))
            if (Number(getTid()) !== item.id) {
                await this.$store.dispatch('tougao/getTouGaoSetting', { tid: item.id })
                await this.$store.dispatch('tougao/getTouGaoInfo', { id: item.id })
            }
            setTid(item.id)
            this.tid = Number(item.id)
            this.zuopintitle = item.title
            this.showZuopinList = true
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.app-wrapper .whtie_wrap .left_content .title_wrap .page_title {
    font-size: 24px;
    font-weight: bold;
}
.app-wrapper .whtie_wrap {
    max-width: 1200px;
    min-height: 800px;
    margin: 30px auto;
    box-sizing: border-box;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.lis_wrap {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
